export class MyConfigurationModel {
    SlotTime:string; 
    MaxItem:number;
    MaxItemsToSell:number;
}
